import React from 'react';
import {useVeiledere} from '../context/VeilederContext';
import {Item, Section} from '../components/types';

const extractKravSections = (data: any) => {
  const sections: Section[] = [];

  if (data && data.krav) {
    if (data.krav.links) {
      sections.push({
        title: 'Generelle krav',
        data: data.krav.links,
      });
    }

    Object.keys(data.krav).forEach(key => {
      if (key !== 'links' && data.krav[key]?.links) {
        sections.push({
          title: data.krav[key].name,
          data: data.krav[key].links,
        });
      }
    });
  }

  return sections;
};

export const KravScreen = () => {
  const veiledere = useVeiledere();

  const sections = veiledere ? extractKravSections(veiledere) : [];

  return (
    <div className="screenContainer">
      {sections.length > 0 ? (
        sections.map((section, sectionIndex) => (
          <div key={sectionIndex}>
            <h2 className="sectionHeader sectionHeaderKrav">{section.title}</h2>
            <ul>
              {section.data.map((item: Item, itemIndex: number) => (
                <li key={item.url + itemIndex}>
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="linkButton">
                    <span className="linkText">{item.name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))
      ) : (
        <p>Henter ny informasjon...</p>
      )}
    </div>
  );
};

export default KravScreen;
